import { Component } from "react";
import { withRouter } from "react-router-dom";
import Lottie from 'react-lottie';
import * as paperPlaneData from '../../components/assets/json/lottie/paper-plane.json'
// import PaperAirplane from '../../components/assets/images/paper-airplane.svg';
// import RobotWriting from '../../components/assets/images/robot-writing.svg';

import "./style.scss";

class ThanksFor extends Component {
    componentDidMount() {
        window.addEventListener("resize", this.resizeHandler);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeHandler);
    }

    resizeHandler = () => {
        let innerWidth = window.innerWidth;
        if ((innerWidth < 600 && this.lastWidth >= 600) ||
            (innerWidth >=600 && this.lastWidth <600)) this.forceUpdate();
    }

    render() {
        let isMobile = window.innerWidth>=600 ? false : true;

        this.lastWidth = window.innerWidth;

        return (
            <>
                <div className={`full-container full-wide center thanks-for ${this.props.className}`}>
                    <div className="section-box row center">
                        <div className="box">
                            {this.props.children}
                            <div className="robot-writing">
                                <Lottie options={{
                                    loop: false,
                                    autoplay: true,
                                    animationData: isMobile ? this.props.robotArmDataM.default : this.props.robotArmDataD.default,
                                }}
                                    height="100%"
                                    width="100%" />
                            </div>
                            {/* <div className="paper-airplane"><img src={PaperAirplane} alt="Paper Airplane" /></div> */}
                            <div className="paper-airplane">
                                <Lottie options={{
                                    loop: false,
                                    autoplay: true,
                                    animationData: paperPlaneData.default,
                                }}
                                    height="100%"
                                    width="100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(ThanksFor);